import { jsx as _jsx } from "react/jsx-runtime";
import { TextAlpha } from '@yonderland/andes-react';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
export const ProductCareDescription = ({ description }) => (_jsx(TextAlpha, { variant: "bodyS", children: _jsx(HtmlInclude, { htmlFragment: description }) }));
